// Rooms
export const REQUEST_ROOMS_PENDING = 'REQUEST_ROOMS_PENDING';
export const REQUEST_ROOMS_SUCCESS = 'REQUEST_ROOMS_SUCCESS';
export const REQUEST_ROOMS_FAILED = 'REQUEST_ROOMS_FAILED';
export const SET_ROOM = 'SET_ROOM';
export const ADD_ROOM = 'ADD_ROOM';
export const RECEIVE_ROOM = 'RECEIVE_ROOM';

// Messages
export const REQUEST_MESSAGES_PENDING = 'REQUEST_MESSAGES_PENDING';
export const REQUEST_MESSAGES_SUCCESS = 'REQUEST_MESSAGES_SUCCESS';
export const REQUEST_MESSAGES_FAILED = 'REQUEST_MESSAGES_FAILED';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';

// User Info
export const SET_USERNAME = 'SET_USERNAME';

//Token
export const REQUEST_TOKEN = "REQUEST_TOKEN";


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js